import { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import { getAdminLogs } from "../client/admin";

function LogPage() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  async function loadData() {
    const res = await getAdminLogs({
      page: page + 1,
      page_size: pageSize,
    });
    if (res) {
      setRows(res.list || []);
      setTotal(res.total || 0);
    }
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        操作日志
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>管理员</TableCell>
              <TableCell>操作</TableCell>
              <TableCell>目标ID</TableCell>
              <TableCell>详情</TableCell>
              <TableCell>时间</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.admin_username || row.admin_id}</TableCell>
                <TableCell>{row.action}</TableCell>
                <TableCell>{row.target_id || "-"}</TableCell>
                <TableCell>
                  <Box sx={{ maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {row.detail || "-"}
                  </Box>
                </TableCell>
                <TableCell>
                  {row.created_at ? new Date(row.created_at).toLocaleString() : "-"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        rowsPerPage={pageSize}
        onRowsPerPageChange={(e) => {
          setPageSize(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 20, 50]}
      />
    </Box>
  );
}

export default LogPage;
